import React from "react";
import Spinner from "./Spinner";

/**
 * Suspense fallback for lazy-loaded routes. Keeps the navbar/footer in place
 * (rendered around <Outlet/>) while a page chunk loads.
 */
const PageLoader = () => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
    <Spinner size="lg" />
    <p className="font-label-sm text-label-sm font-bold uppercase tracking-wider text-on-surface-variant">
      Loading
    </p>
  </div>
);

export default PageLoader;
